<template>
  <div id="app">
    <video style="display:none;" id="video" loop autoplay>
      <source src="./assets/tishiyin.mp3">
    </video>
    <router-view />
  </div>
</template>

<script>
  import Cookies from "js-cookie";
  import Vue from "vue";
  import TRTCCalling from 'trtc-calling-js';
  import TRTC from 'trtc-js-sdk';
  import router from "./router";

  export default {
    name: 'App',
    data() {
      return {}
    },
    created() {
      //this.handleAccount()
    },
    watch: {
      '$store.state.productform.mchid': {
        handler: function (newV, oldV) {
          if (newV) {
            this.$store.commit('get_product')
          }
        }
      },
    },
    methods: {
      // handleAccount() {

      //   //摄像头初始化
      //   let options = {
      //     SDKAppID: parseInt(window.localStorage.getItem('sdkappid'))
      //   };
      //   console.log('---------sdkappid-----------')
      //   console.log(window.localStorage.getItem('sdkappid'))
      //   console.log(Cookies.get('userSig'))
      //   Vue.prototype.$trtcCalling = new TRTCCalling(options)
      //   Vue.prototype.TRTCCalling = TRTCCalling;
      //   Vue.prototype.TRTC = TRTC;

      //   if (Cookies.get('userSig')) {
      //     this.$trtcCalling.login({
      //         userID: Cookies.get("userid"),
      //         userSig: Cookies.get('userSig')
      //       })
      //       .then((e) => {

      //         console.log('------------已登录------------')
      //         console.log(e)
      //         console.log(Cookies.get("userid"))
      //         console.log(Cookies.get("userSig"))
      //       })
      //   }
      //   //展示本地画面
      //   // this.$trtcCalling.startLocalView({
      //   //   userID: Cookies.get('UserID'),
      //   //   videoViewDomID: 'LocalView'
      //   // })
      //   if (Vue.prototype.$trtcCalling) {

      //     // sdk内部发生了错误
      //     this.$trtcCalling.on(this.TRTCCalling.EVENT.ERROR, (error) => {
      //       this.$message.error('sdk内部发生了错误' + error);
      //     })
      //     // 被邀请进行通话
      //     this.$trtcCalling.on(this.TRTCCalling.EVENT.INVITED, this.invited)
      //     // 远端用户同意进入通话
      //     this.$trtcCalling.on(this.TRTCCalling.EVENT.USER_ENTER, (userID) => {
      //       this.userenter(userID)
      //     })
      //     // 远端用户离开通话
      //     this.$trtcCalling.on(this.TRTCCalling.EVENT.USER_LEAVE, () => {
      //       this.$trtcCalling.hangup()
      //       this.$store.commit('calling_end')
      //     })
      //     // 邀请方取消了通话邀请，作为被邀请方会收到
      //     this.$trtcCalling.on(this.TRTCCalling.EVENT.CALLING_CANCEL, () => {
      //       this.$msgbox.close()
      //       this.$message({
      //         message: '对方取消了通话邀请',
      //         type: 'warning'
      //       });
      //     })
      //     // 因为多实例登录或者多终端登录被被踢出im系统
      //     this.$trtcCalling.on(this.TRTCCalling.EVENT.KICKED_OUT, () => {
      //       this.$message.error('因为多实例登录或者多终端登录被被踢出');
      //       Cookies.remove('wx_name');
      //       Cookies.remove('doctortoken');
      //       Cookies.remove('rk_token');
      //       Cookies.remove('role_id');
      //       Cookies.remove('headimg');
      //       Cookies.remove('UserID');
      //       window.localStorage.removeItem('router')
      //       router.push({
      //         name: "login",
      //       })
      //     })
      //     // 超时
      //     this.$trtcCalling.on(this.TRTCCalling.EVENT.CALLING_TIMEOUT, () => {
      //       this.$message({
      //         message: '超时',
      //         type: 'warning'
      //       });
      //       this.$msgbox.close()
      //     })
      //     // 本次通话结束了
      //     this.$trtcCalling.on(this.TRTCCalling.EVENT.CALLING_END, () => {})
      //   } else {

      //   }
      // },
      // invited(payload) {
      //   // var a=document.getElementById('video')
      //   // a.play()
      //   console.log('是否接通')
      //   this.$confirm('<p class="confirmp">您当前有待接通问诊</p><p class="confirmp">是否接通</p>', '', {
      //     confirmButtonText: '是',
      //     cancelButtonText: '否',
      //     showClose: false,
      //     closeOnClickModal: false,
      //     closeOnPressEscape: false,
      //     center: true,
      //     dangerouslyUseHTMLString: true,
      //     cancelButtonClass: 'cancelButtonClass',
      //     confirmButtonClass: 'confirmButtonClass',
      //   }).then(() => {
      //     this.$trtcCalling.accept({
      //       inviteID: payload.inviteID, // 邀请 ID, 标识一次邀请
      //       roomID: payload.inviteData.roomID, // 通话房间号 ID
      //       callType: payload.inviteData.callType // 0-未知， 1-语音通话，2-视频通话
      //     });
      //   }).catch(() => {
      //     this.$trtcCalling.reject({
      //       inviteID: payload.inviteID, // 邀请 ID, 标识一次邀请
      //       isBusy: false, // 是否是忙线中
      //       callType: payload.inviteData.callType // 0-未知， 1-语音通话，2-视频通话
      //     });
      //   });
      // },
      // userenter(userID) {
      //   this.$store.commit('order_id', userID.userID)
      //   this.$get(this.$api + '/consultation_room/doctor_receive_order', {
      //       order_id: userID.userID
      //     })
      //     .then((res) => {
      //       if (res.code === 0) {
      //         this.$store.commit('get_order_model', userID.userID)
      //         this.$store.commit('get_upload_pic', userID.userID)
      //         setInterval(() => {
      //           this.$store.commit('get_upload_pic', userID.userID)
      //         }, 5000)
      //         //展示远端画面
      //         Vue.prototype.$trtcCalling.startRemoteView({
      //           userID: userID.userID,
      //           videoViewDomID: "RemoteView"
      //         })
      //         //展示本地画面
      //         Vue.prototype.$trtcCalling.startLocalView({
      //           userID: Cookies.get('UserID'),
      //           videoViewDomID: 'LocalView'
      //         })
      //       } else {
      //         this.$notify({
      //           title: '失败',
      //           message: res.msg,
      //           type: 'error'
      //         });
      //       }
      //     })
      // },
    }
  }

</script>

<style>
  #app {
    overflow: auto;
    width: 100%;
    height: 100%;
  }

  .confirmp {
    color: #1DBFC1;
    font-size: 30px;
    height: 42px;
    line-height: 42px;
  }

  .cancelButtonClass {
    font-size: 26px;
    color: #FE8067;
    background: #FFEEE6;
    border: 1px solid #FE8066;
    box-sizing: border-box;
    border-radius: 5px;
  }

  .cancelButtonClass.el-button:focus,
  .cancelButtonClass.el-button:hover {
    color: #FE8067;
    background: #FFEEE6;
    border: 1px solid #FE8066;
  }

  .confirmButtonClass {
    font-size: 26px;
    color: #1DBFC1;
    background: #DBF0ED;
    border: 1px solid #1DBFC1;
    box-sizing: border-box;
    border-radius: 5px;
  }

  .confirmButtonClass.el-button--primary {
    color: #1DBFC1;
    background: #DBF0ED;
    border: 1px solid #1DBFC1;
  }

  .el-message-box .el-message-box__btns button:nth-child(2) {
    margin-left: 10px;
  }

  .el-message-box__btns button:nth-child(2) {
    margin-left: 90px;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue